// extracted by mini-css-extract-plugin
export default {"wrapper":"burger-constructor-empty_wrapper__4mtza","img":"burger-constructor-empty_img__GQsgk"};